import React, {Fragment, useEffect, useState} from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import {Card, CardBody, Col, Row} from "reactstrap";
import List from "Pages/Admin/Logging/List";

import PageHeading from "Layout/AppMain/PageHeading";


const Default = () => {
   
    return (
        <Fragment>
            <PageHeading/>
            <TransitionOnLoad>
                    <div>
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <List />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </TransitionOnLoad>
        </Fragment>
    )
};

export default Default;